module.exports = __webpack_public_path__ + "img/h5.dcf8cad2.png";